// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_1f_sq","startPage":"style_startPage_2_zHJ"};